import { render, staticRenderFns } from "./Documentos.vue?vue&type=template&id=17b10946&scoped=true&"
import script from "./Documentos.vue?vue&type=script&lang=js&"
export * from "./Documentos.vue?vue&type=script&lang=js&"
import style0 from "./Documentos.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Documentos.vue?vue&type=style&index=1&id=17b10946&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17b10946",
  null
  
)

export default component.exports